<hr/>

<style>
  hr {
    width: 100%;
    color: lightgrey;
  }
</style>